import declare from "dojo/_base/declare";
import BooleanRen from "csi/heading/Boolean";

const Default3DEnvironmentRenderer = declare(BooleanRen, {

	/**
	 * @override
	 * Disable
	 */
	_getRenderAction: function(ctx, h) {
		const node = ctx.getNode();
		return node.Default || !node.Active ? null : this.inherited(arguments);
	},
});

export = Default3DEnvironmentRenderer;
